import React from "react";
import IconProps from "./types";

const ToggleLeft: React.FC<IconProps> = ({
  width = 16,
  height = 16,
  fill = "currentColor",
  className = "",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <path
        d="M13.3333 4.14262e-09C14.0135 -3.7886e-05 14.668 0.259845 15.1629 0.726474C15.6578 1.1931 15.9557 1.83121 15.9956 2.51022L16 2.66667V13.3333C16 14.0135 15.7402 14.668 15.2735 15.1629C14.8069 15.6578 14.1688 15.9557 13.4898 15.9956L13.3333 16H2.66667C1.98648 16 1.33199 15.7402 0.837101 15.2735C0.342216 14.8069 0.0443489 14.1688 0.00444455 13.4898L4.14262e-09 13.3333V2.66667C-3.7886e-05 1.98648 0.259845 1.33199 0.726474 0.837101C1.1931 0.342216 1.83121 0.0443489 2.51022 0.00444455L2.66667 4.14262e-09H13.3333ZM13.3333 1.77778H5.33333V14.2222H13.3333C13.5511 14.2222 13.7612 14.1423 13.9239 13.9976C14.0866 13.8529 14.1905 13.6536 14.216 13.4373L14.2222 13.3333V2.66667C14.2222 2.44895 14.1423 2.23881 13.9976 2.07611C13.8529 1.91342 13.6536 1.80947 13.4373 1.784L13.3333 1.77778ZM11.2951 5.59378C11.4482 5.74684 11.5401 5.95048 11.5537 6.16651C11.5673 6.38253 11.5016 6.59609 11.3689 6.76711L11.2951 6.85067L10.1467 8L11.2951 9.14933C11.4482 9.30239 11.5401 9.50604 11.5537 9.72206C11.5673 9.93808 11.5016 10.1516 11.3689 10.3227L11.2951 10.4062C11.1421 10.5593 10.9384 10.6512 10.7224 10.6648C10.5064 10.6784 10.2928 10.6127 10.1218 10.48L10.0382 10.4062L8.26044 8.62844C8.1074 8.47538 8.01546 8.27174 8.00188 8.05572C7.98829 7.83969 8.054 7.62614 8.18667 7.45511L8.26044 7.37156L10.0382 5.59378C10.2049 5.42714 10.431 5.33352 10.6667 5.33352C10.9024 5.33352 11.1284 5.42714 11.2951 5.59378Z"
        fill={fill}
      />
    </svg>
  );
};

export default ToggleLeft;
